import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'data/root.reducers';
import { TOAST_TIMEOUT, showError } from 'shared/toaster';
import {
  SupportedFeaturesAccessFunctions,
  SupportedFeaturesCollectionFunctions
} from 'data/supportedFeatures/supportedFeatures.types';
import extractErrorMessage from 'utils/axios';
import i18n from 'i18n';
import { ServerResponse } from 'data/types';
import { AxiosResponse } from 'axios';
import * as api from './network-topology.api';
import {
  GET_NETWORK_TOPOLOGY,
  GET_NETWORK_TOPOLOGY_FILTERS,
  SET_NETWORK_TOPOLOGY_FILTER,
  SAVE_NETWORK_TOPOLOGY_FILTER,
  FILTER_NETWORK_TOPOLOGY,
  NetworkTopologyFilter,
  LOAD_MOCK_DATA_FILE,
  MOCK_DATA_ENUM,
  GET_NETWORK_TOPOLOGY_FULFILLED,
  GetNetworkTopologyFulfilledAction,
  NetworkTopologyElementsEnum,
  LOAD_MOCK_DATA_FILE_FULFILLED,
  LoadMockDataFileFulfilledAction,
  GET_NETWORK_TOPOLOGY_CONFIG
} from './network-topology.types';

export function getNetworkTopologyActions(
  deliveryFunctionId: string,
  shouldUseNetworkTopologyMockData?: { [key: string]: number },
  shouldUseNetworkTopologyDinamicLocations?: boolean,
) {
  return {
    type: GET_NETWORK_TOPOLOGY,
    payload: {
      deliveryFunctionId,
      shouldUseNetworkTopologyMockData,
      shouldUseNetworkTopologyDinamicLocations,
    },
  };
}

export function filterNetworkTopologyAction(payload: {
  filter: NetworkTopologyFilter,
  availableAccessFunction: SupportedFeaturesAccessFunctions,
  availableCollectionFunction: SupportedFeaturesCollectionFunctions,
}) {
  return (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    dispatch({
      type: FILTER_NETWORK_TOPOLOGY,
      payload,
    });
  };
}

export function setNetworkTopologyFilter(payload: NetworkTopologyFilter) {
  return (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    dispatch({
      type: SET_NETWORK_TOPOLOGY_FILTER,
      payload,
    });
  };
}

export function getNetworkTopologyCustomFilters() {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: GET_NETWORK_TOPOLOGY_FILTERS,
        payload: api.getNetworkTopologyCustomFilters(),
      });
    } catch (error: any) {
      showError(error);
    }
  };
}

export function createNetworkTopologyFilter(body: NetworkTopologyFilter) {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: SAVE_NETWORK_TOPOLOGY_FILTER,
        payload: api.createNetworkTopologyCustomFilter(body),
      });
    } catch (error: any) {
      showError(error);
    }
  };
}

export function loadMockDataFile(filename: MOCK_DATA_ENUM) {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: LOAD_MOCK_DATA_FILE,
        payload: api.getMockDataFile(filename),
      });
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error);
      showError(i18n.t('networkTopology.mock.files.failed', { error: errorMessage }), TOAST_TIMEOUT);
    }
  };
}

export function loadMockDataFileFulfilled(
  response: AxiosResponse<ServerResponse<any>>
): LoadMockDataFileFulfilledAction {
  return {
    type: LOAD_MOCK_DATA_FILE_FULFILLED,
    payload: response,
  };
}

export function getNetworkTopologyFulfilled(
  response: { element: NetworkTopologyElementsEnum; data: unknown[]; }[],
): GetNetworkTopologyFulfilledAction {
  return {
    type: GET_NETWORK_TOPOLOGY_FULFILLED,
    payload: response,
  };
}

export function getNetworkTopologyConfig() {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: GET_NETWORK_TOPOLOGY_CONFIG,
        payload: api.getNetworkTopologyConfig()
      });
    } catch (error: any) {
      showError(error);
    }
  };
}
